import QuickBooksSourceBanner from './QuickBooksSourceBanner';
import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import StoreMappingManager from './StoreMappingManager';
import BrandRulesManager from './BrandRulesManager';
import QBAccountMapper from './QBAccountMapper';
import CostAllocationManager from './CostAllocationManager';
import AccrualVendorsManager from './AccrualVendorsManager';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`config-tabpanel-${index}`}
      aria-labelledby={`config-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ConfigurationSettings() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      <QuickBooksSourceBanner variant="settings" />
      <Typography variant="h4" gutterBottom>
        Financial Configuration Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure store-to-QuickBooks mappings and default mapping rules for automatic suggestions
      </Typography>

      <Card>
        <CardContent>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Store Mappings" id="config-tab-0" aria-controls="config-tabpanel-0" />
            <Tab label="Company Rules" id="config-tab-1" aria-controls="config-tabpanel-1" />
            <Tab label="QB Account Categories" id="config-tab-2" aria-controls="config-tabpanel-2" />
            <Tab label="Cost Allocations" id="config-tab-3" aria-controls="config-tabpanel-3" />
            <Tab label="Accrual Vendors" id="config-tab-4" aria-controls="config-tabpanel-4" />
          </Tabs>

          <TabPanel value={currentTab} index={0}>
            <StoreMappingManager />
          </TabPanel>

          <TabPanel value={currentTab} index={1}>
            <BrandRulesManager />
          </TabPanel>

          <TabPanel value={currentTab} index={2}>
            <QBAccountMapper />
          </TabPanel>

          <TabPanel value={currentTab} index={3}>
            <CostAllocationManager />
          </TabPanel>

          <TabPanel value={currentTab} index={4}>
            <AccrualVendorsManager />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
}
